<template>
    <router-view />
</template>

<style src="@/assets/lib/bootstrap/2.3.2/css/bootstrap.min.css"></style>
<style src="@/assets/lib/bootstrap/2.3.2/css/bootstrap-responsive.min.css"></style>
<style src="@/assets/lib/font-awesome/3.2.1/css/font-awesome.min.css"></style>
<style src="@/assets/lib/checkout-ui/v5.23.5/style/style.css"></style>
<style src="@/assets/css/gt-checkout-2.css"></style>

<script>

    export default {
        mounted() {

        }
    }

</script>
